<template>
  <v-app :style="bgThread(this.bg)">
    <div class="full-width flexbox">
      <v-container>
        <div class="max-width-table">
          <v-row>
            <v-col
              cols
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="center-align"
            >
              <span
                class="color-white"
                style="font-weight:bolder; font-size:2rem ;"
                >PÁGINA EN<br />CONSTRUCCIÓN</span
              >
              <hr style="border: 1px solid #C32724; width:50% ;margin-left:25%;" />
            </v-col>
            <v-col cols xl="12" lg="12" md="12" sm="12" xs="12" class="flexbox">
              <img
                :src="image(this.logo.name, this.logo.ext)"
                style="height: 78px;"
              />
            </v-col>
            <v-col
              cols
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              text-color="white"
              class="center-align"
            >
              <span class="color-white" style="font-weight:light;"
                >Estamos trabajando para mejorar. Regresa pronto o comunícate
                con nosotros para brindarte más información</span
              >
            </v-col>
          </v-row>
          <v-row class="d-md-none d-lg-none d-xl-none">
            <v-col cols xl="4" lg="4" md="4" sm="12" xs="12" class="flexbox">
              <img
                :src="image(this.icons[0].name, this.icons[0].ext)"
                style="height: 60px;"
              />
            </v-col>
            <v-col cols xl="4" lg="4" md="4" sm="12" xs="12" class="flexbox">
              <img
                :src="image(this.icons[1].name, this.icons[1].ext)"
                style="height: 48px;"
              />
            </v-col>
            <v-col cols xl="4" lg="4" md="4" sm="12" xs="12" class="flexbox">
              <img
                :src="image(this.icons[2].name, this.icons[2].ext)"
                style="height: 60px; width:114px;"
              />
            </v-col>
          </v-row>
        </div>
      </v-container>
    </div>

    <v-footer
      class="d-none d-xs-none d-sm-none d-md-flex"
      color="transparent"
      padless
      fixed
      style="max-width: 500px; margin: auto; padding:20px 0px 20px 0px;"
    >
      <v-row>
        <v-col cols xl="4" lg="4" md="4" sm="12" xs="12" class="flexbox">
          <img
            :src="image(this.icons[0].name, this.icons[0].ext)"
            style="height: 48px;"
          />
        </v-col>
        <v-col cols xl="4" lg="4" md="4" sm="12" xs="12" class="flexbox">
          <img
            :src="image(this.icons[1].name, this.icons[1].ext)"
            style="height: 48px;"
          />
        </v-col>
        <v-col cols xl="4" lg="4" md="4" sm="12" xs="12" class="flexbox">
          <img
            :src="image(this.icons[2].name, this.icons[2].ext)"
            style="height: 48px;"
          />
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { bgThread, image } from "@/mixins/bgimages";
export default {
  mixins: [bgThread, image],
  name: "App",

  data: () => ({
    bg: "Portada.png",
    logo: {
      name: "Logotipo 1",
      ext: "png",
    },
    icons: [
      {
        name: "Logotipo Chronos",
        ext: "svg",
      },
      {
        name: "Logotipo Grupo Merca",
        ext: "svg",
      },
      {
        name: "Logotipo Yego",
        ext: "svg",
      },
    ],
  }),
};
</script>
<style>
@font-face {
  font-family: "Century Gothic";
  src: url("~@/assets/fonts/CenturyGothic.ttf") format("truetype");
}
body{overflow-x: hidden;overflow-y: hidden;}

.flexbox {
  display: flex;
  align-items: center;
  justify-content: center;
}
.full-width {
  width: 100vw;
  height: 100vh;
  font-family: "Century Gothic";
}
.max-width-table {
  max-width: 500px;
  margin: auto;
}
.color-white {
  color: #ffffff;
}
.center-align {
  text-align: center;
}
.space {
  margin-top: 500px;
}
@media only screen and (max-width: 690px) {
}
</style>
